
//外部リンク
const links = document.querySelectorAll('a');
for (let i = 0; i < links.length; i++) {
	if (links[i].hostname !== window.location.hostname) {
		links[i].target = '_blank';
		links[i].rel = 'noreferrer noopener';
	}
}

//フッターリンク
const footMenuTitles = document.getElementsByClassName('footMenuTitle');
for (let i = 0; i < footMenuTitles.length; i++) {
	footMenuTitles[i].addEventListener('click', function () {
		this.classList.toggle('is-active');
		const answer = this.nextElementSibling;
		if (answer.style.maxHeight) {
			answer.style.maxHeight = null;
		} else {
			answer.style.maxHeight = answer.scrollHeight + "px";
		}
	});
};

//pagetop
window.addEventListener('scroll', () => {
	var scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
	const pagetopBtn = this.document.getElementsByClassName('pagetop');
	if (scrollPosition > 200) {
		pagetopBtn[0].classList.add('is-show');
	} else {
		pagetopBtn[0].classList.remove('is-show');
	}
});
